import { persistSessionStartedAt } from "utils/sessionTiming";

// MSAL refuses to start a redirect while its "an interaction is in progress" flag is set
// (BrowserAuthError interaction_in_progress). The flag is kept under a key ending in
// "interaction.status" — in sessionStorage by default — so localStorage.clear() alone never
// removes it, and a flag left by an earlier redirect that never finished makes the next
// logoutRedirect throw (an uncaught rejection, and the red error overlay in development).
const INTERACTION_STATUS_SUFFIX = "interaction.status";

export const clearMsalInteractionStatus = () => {
  [window.sessionStorage, window.localStorage].forEach((storage) => {
    try {
      Object.keys(storage)
        .filter((key) => key.endsWith(INTERACTION_STATUS_SUFFIX))
        .forEach((key) => storage.removeItem(key));
    } catch (e) {
      // Storage can be unavailable (private mode / blocked); nothing to clear then.
    }
  });
};

// Signs the user out via MSAL's logout redirect. Clears the session clock, local storage and any stale
// MSAL "in progress" flag first, and never lets a refused redirect surface as an uncaught error: if MSAL
// still won't start it, the local sign-out is already done, so it just sends the browser to the start page.
export const redirectToLogout = async (instance, postLogoutRedirectUri = "/") => {
  persistSessionStartedAt(null);
  localStorage.clear();
  clearMsalInteractionStatus();
  try {
    await instance.logoutRedirect({ postLogoutRedirectUri });
  } catch (e) {
    clearMsalInteractionStatus();
    window.location.assign(postLogoutRedirectUri);
  }
};
